import React, { useEffect, useState } from "react";
import "./Analytics.css";
import patient from "../../images/patient.png";
import doctor from "../../images/doctor.png";
import forum from "../../images/forum.png";
import rating from "../../images/rating.png";

import {
  getTotalPatientCount,
  getTotalDoctorCount,
  getTotalForumCount,
  getAverageRating,
} from "../services/analyticsService";
import { useSelector } from "react-redux";

function StatisticCard() {
  const token = useSelector((state) => state?.login?.data?.accessToken);

  const [statistic, setStatistic] = useState({
    totalPatients: 0,
    totalDoctors: 0,
    totalForums: 0,
    averageRating: 0,
  });

  // Common function to fetch all required data
  const _fetchStatisticData = async () => {
    try {
      const [patientResponse, doctorResponse, forumResponse, averageRating] =
        await Promise.all([
          getTotalPatientCount(token),
          getTotalDoctorCount(token),
          getTotalForumCount(token),
          getAverageRating(token),
        ]);

      setStatistic({
        totalPatients: patientResponse?.data?.allCount || 0,
        totalDoctors: doctorResponse?.data?.allCount || 0,
        totalForums: forumResponse?.data?.allForumCount || 0,
        averageRating: averageRating?.data || 0,
      });
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    }
  };

  useEffect(() => {
    _fetchStatisticData();
  }, []);

  return (
    <div className="adminDashboard-wrapper">
      <div className="admindashboard-inner-wrapper">
        <div className="adminDashboard-top-blk mb-4">
          <div className="common-block-area ">
            <div className="block orange-blk  ">
              <div className="content">
                <p className="content-text">
                  <span className="numbers-list">
                    {statistic?.totalPatients}
                  </span>{" "}
                  Total Patients
                </p>
                <img src={patient} alt="icon" />
              </div>
              <div className="circle orange-shade"></div>
            </div>
            <div className="block green-blk">
              <div className="content">
                <p className="content-text">
                  <span className="numbers-list">
                    {statistic?.totalDoctors}
                  </span>{" "}
                  Total Doctors
                </p>
                <img src={doctor} alt="icon" />
              </div>
              <div className="circle green-shade"></div>
            </div>
            <div className="block gray-blk">
              <div className="content">
                <p className="content-text">
                  <span className="numbers-list">{statistic?.totalForums}</span>
                  Total Forums
                </p>
                <img src={forum} alt="icon" />
              </div>
              <div className="circle gray-shade"></div>
            </div>
            <div className="block purple-blk">
              <div className="content">
                <p className="content-text">
                  <span className="numbers-list">
                    {statistic.averageRating}
                  </span>{" "}
                  Rating
                </p>
                <img src={rating} alt="icon" />
              </div>
              <div className="circle purple-shade"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default StatisticCard;
